import { render, staticRenderFns } from "./ExpertHome.vue?vue&type=template&id=d33adde6&scoped=true"
import script from "./ExpertHome.vue?vue&type=script&lang=ts"
export * from "./ExpertHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33adde6",
  null
  
)

export default component.exports